import { useLanguage } from "@/contexts/LanguageContext";
import { Users, ShieldAlert, ShieldCheck, Swords } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const MarketProblemSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground text-center mb-6">
          {t.marketProblem.title}
        </h2>
        <p className="text-center text-muted-foreground max-w-2xl mx-auto mb-16">
          {t.marketProblem.description}
        </p>

        <div className="relative max-w-5xl mx-auto grid md:grid-cols-2 gap-8">
          {/* Center VS badge + lines (desktop only) */}
          <div className="hidden md:flex absolute inset-y-0 left-1/2 -translate-x-1/2 flex-col items-center z-10 pointer-events-none">
            <div className="flex-1 w-px bg-border" />
            <div className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-sm shadow-md shrink-0">
              VS
            </div>
            <div className="flex-1 w-px bg-border" />
          </div>

          {/* Standard card — white, flat */}
          <div className="relative rounded-2xl border border-border bg-card p-8">
            <div className="text-xs uppercase tracking-wider text-destructive font-semibold mb-6">
              ❌ {t.marketProblem.standard.title}
            </div>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-destructive/10 flex items-center justify-center">
                  <Users className="h-5 w-5 text-destructive" />
                </div>
                <div>
                  <div className="text-lg font-bold text-foreground">{t.marketProblem.standard.seller}</div>
                  <div className="text-sm text-muted-foreground">+ {t.marketProblem.standard.sellerBroker}</div>
                </div>
              </div>
              <p className="text-sm text-muted-foreground italic pl-13">
                {t.marketProblem.standard.wantHighPrice}
              </p>
              <div className="text-center font-bold text-muted-foreground text-lg py-2 md:hidden">
                {t.marketProblem.standard.vs}
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-muted flex items-center justify-center">
                  <ShieldAlert className="h-5 w-5 text-muted-foreground" />
                </div>
                <div className="text-lg font-bold text-muted-foreground">
                  {t.marketProblem.standard.lonelyBuyer}
                </div>
              </div>
            </div>
          </div>

          {/* Dealigator card — white with green border + elevation */}
          <div className="relative rounded-2xl border-2 border-primary bg-card p-8 shadow-xl">
            <div className="text-xs uppercase tracking-wider text-primary font-semibold mb-6">
              ✅ {t.marketProblem.dealigator.title}
            </div>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                  <ShieldCheck className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <div className="text-lg font-bold text-foreground">{t.marketProblem.dealigator.buyer}</div>
                  <div className="text-sm text-primary font-medium">+ {t.marketProblem.dealigator.aiLawyerNegotiator}</div>
                </div>
              </div>
              <p className="text-sm text-primary/80 italic pl-13">
                {t.marketProblem.dealigator.fullProtection}
              </p>
              <div className="text-center font-bold text-muted-foreground text-lg py-2 md:hidden">
                {t.marketProblem.dealigator.vs}
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-muted flex items-center justify-center">
                  <Swords className="h-5 w-5 text-muted-foreground" />
                </div>
                <div className="text-lg font-bold text-muted-foreground">
                  {t.marketProblem.dealigator.seller}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketProblemSection;
